class CartItemController {
    constructor($timeout, config, trolleySource, analyticsService, trolleyService, cartItemMessageService, announcerService) {
        this.$timeout = $timeout;
        this.config = config;
        this.trolleySource = trolleySource;
        this.analyticsService = analyticsService;
        this.trolleyService = trolleyService;
        this.cartItemMessageService = cartItemMessageService;
        this.announcerService = announcerService;
    }

    onError(reason) {
        this.analyticsService.pushError(reason);

        this.error = reason;
    }

    onSuccess() {
        this.clearError();
    }

    clearError() {
        this.error = null;

        this.cartItemMessageService.clearErrors(this.trolleyItem.Stockcode);
    }

    remove() {
        this.trolleyService.removeTrolleyItem(this.trolleyItem.Stockcode)
            .then(() => {
                this.cartItemMessageService.removeItemMessages(this.trolleyItem.Stockcode);
                this.announcerService.announce(`${this.trolleyItem.Name} removed from trolley`);
            });
    }
}

const cartItemComponentDefinition = {
    bindings: {
        trolleyItem: '<',
        classModifier: '@?',
    },
    controller: ['$timeout', 'config', 'TrolleySource', 'AnalyticsService', 'TrolleyService', 'CartItemMessageService', 'AnnouncerService', CartItemController],
    template: require('./cart-item.component.html').trim(),
};

module.exports = {
    CartItemController,
    cartItemComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-item.component.js